import api from "../api";
import cfg from "../cfg";
import tx from "../tx";

let idParking = 0
let parkings = [];

const blankCache = {
    products:null,
    productNames:[]
}

let cache = { ...blankCache };

async function getAll() {
    if (parkings.length > 0)
        return parkings;

    let response = await api.list('parking');
    parkings = response.data;
    return parkings;
}

function setIdParking(id) {
    if (id === idParking) return;
    idParking = id;
    cache = { ...blankCache };
}

async function getProducts() {
    if (!cache.products) {
        let response  = await api.list('product', {
            columns: ["id", "name"],
            row_count: 0,
            count_rows: false,
            filters: { "parking_id": idParking }
        });
        if (response.ok) {
            cache.products = response.data;
            for (let product of cache.products)
                cache.productNames["id"+product.id]=product.name;
        }
    }
    return cache.products;
}

async function apiGet() {
    return await api.getId('parking',idParking);
}

async function apiUpdate(data) {
    return await api.update('parking', {...data, id:idParking});
}


async function getProductName(id) {
    if (cache.productNames['id'+id])
    return cache.productNames['id'+id];
    let response = await api.getId('product', id);
    if (response.ok)
        return response.data.name;

    return tx.t('Product')+' '+id;
}



export default {
    getId: ()=>idParking,
    getAll,
    getProducts, getProductName,
    setIdParking,
    apiGet, apiUpdate
}
